import { Chat } from '@/redux/chat/types'
import { call, put } from 'redux-saga/effects'
import { loadChatsByStatusAction, setHasMoreChatsAction } from '../../actions'
import { api } from '@/services/api'
import { ChatFilters } from '../../handles/loadChatsByStatusAction/types'

const CHATS_LIMIT = 100

export function* loadChatsByStatusSaga(action: ReturnType<typeof loadChatsByStatusAction.request>) {
  const { status, ownerId, operatorId, campaignIds, departmentId, isChatsWithUnreadedMessages, chatFilters } =
    action.payload
  try {
    const { chats, hasMore } = yield call(
      fetchChats,
      status,
      ownerId,
      operatorId,
      campaignIds,
      departmentId,
      isChatsWithUnreadedMessages,
      chatFilters
    )
    yield put(
      setHasMoreChatsAction({
        state: hasMore,
        status: isChatsWithUnreadedMessages ? ['chats_with_unread_messages'] : status
      })
    )
    yield put(loadChatsByStatusAction.success({ chats, status, isChatsWithUnreadedMessages }))
  } catch (error) {
    yield put(loadChatsByStatusAction.failure(error))
  }
}

function* fetchChats(
  status: string[],
  ownerId: string,
  operatorId: string,
  campaignIds: string[],
  departmentId: string,
  isChatsWithUnreadedMessages?: boolean,
  chatFilters?: ChatFilters
) {
  const { campaignIds: filteredCampaignIds, ...filters } = chatFilters || {}
  const customCampaignIds = filteredCampaignIds?.length ? filteredCampaignIds : campaignIds

  const response = yield api.post('/mongo/chats/get-chats-by-status', {
    ownerId,
    status,
    campaignIds: customCampaignIds,
    operatorId,
    departmentId,
    isChatsWithUnreadedMessages,
    chatFilters: filters,
    // ask for one extra item to derive hasMore when backend doesn't send it
    queryLimit: CHATS_LIMIT + 1
  })
  let chats = (response?.data?.chats as Chat[]) || []
  const backendHasMore: boolean | undefined = response?.data?.hasMore
  const derivedHasMore = chats.length > CHATS_LIMIT
  const hasMore = typeof backendHasMore === 'boolean' ? backendHasMore : derivedHasMore
  if (typeof backendHasMore !== 'boolean' && derivedHasMore) {
    chats = chats.slice(0, CHATS_LIMIT)
  }
  return { chats, hasMore }
}
